import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { createEmptySupplier, clearToast } from 'Reducers/supplierReducer'
import { STATUS } from 'Reducers/actions/supplierActions'
import { connect } from 'react-redux'
import SupplierForm from 'Modules/supplier/supplierForm'

class SupplierCreate extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    this.props.createEmptySupplier()
  }
  componentDidUpdate() {
    if (this.props.loadingState === STATUS.SUPPLIER_SUCCESS) {
      toast.success('Successfully Created', {
        autoClose: 7500,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast(STATUS.IS_REDIRECT)
    }
    if (this.props.loadingState === STATUS.SUPPLIER_FAILED) {
      toast.error('Error while saving Supplier', {
        autoClose: 7500,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast()
    }
  }

  render() {
    return (
      <React.Fragment>
        <SupplierForm {...this.props} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ loadingState: state.supplier.loadingState })

export default connect(mapStateToProps, { createEmptySupplier, clearToast })(SupplierCreate)
